<template>
	<section class="reservation-summary">
		<div v-if="isRegularUser === false">
			<div class="reservation-summary__top">
				<div class="rs-content">
					<h2>예약 접수 현황</h2>
					<p>
						붙여핸썸은 하이모 이용고객님을 위한 서비스어플입니다.<br />
						붙여핸썸을 통한 예약은 하이모 정회원부터 이용가능하므로<br />
						정회원 전환하기 완료 후 이용해주세요.
					</p>
				</div>
			</div>

			<div class="reservation-summary__bottom">
				<a
					@click="updateUserLevelToRegular"
					href="javascript:;"
					class="btn-rs btn-rs--apply"
					>정회원 전환하기</a
				>
			</div>
		</div>

		<div v-if="isRegularUser === true && isUserReservationStateList === true">
			<div class="reservation-summary__top">
				<ul class="rs-status-list">
					<li
						v-for="item in userReservationStateList"
						:key="item.INDEX"
						class="rs-status-list__item"
					>
						<div class="rs-status">
							<div
								:class="['rs-status__status', getReservationStatusClass(item)]"
							>
								<div class="rs-status__inner">
									{{ item.STATUS_NAME }}
								</div>
							</div>
						</div>
						<div class="rs-detail">
							<h2 class="rs-detail__title u-font-weight-500">
								{{ item.DEPT_NAME }}
							</h2>
							<p class="rs-detail__text u-font-weight-500">
								{{ getFormatedReservationDate(item.RSRV_DT) }}
								{{ getFormatedReservationTime(item.RSRV_TM_NAME) }}
							</p>
							<p
								v-if="item.RSRV_SV_CODE"
								class="rs-detail__text u-font-weight-500"
							>
								{{ getReservationServiceName(item.RSRV_SV_CODE) }}
							</p>
						</div>
						<div class="rs-button">
							<button
								v-if="getReservationStatus(item) === 'complete'"
								@click="goToReservationDetail()"
								class="rs-button__btn rs-button__btn--cancel"
								type="button"
							>
								취소
							</button>

							<button
								v-if="getReservationStatus(item) === 'possible'"
								@click="goToReservationApp(item.DEPT_NAME)"
								class="rs-button__btn rs-button__btn--apply u-font-weight-700"
								type="button"
							>
								예약
							</button>

							<button
								v-if="getReservationStatus(item) === 'waiting'"
								@click="goToReservationWaiting()"
								class="rs-button__btn rs-button__btn--cancel"
								type="button"
							>
								취소
							</button>
						</div>
					</li>
				</ul>
			</div>

			<div class="reservation-summary__bottom">
				<router-link :to="{ name: 'reservation' }" class="btn-rs btn-rs--apply"
					>예약 내역 확인</router-link
				>
			</div>
		</div>

		<div v-if="isRegularUser === true && isUserReservationStateList === false">
			<div class="reservation-summary__top">
				<div class="rs-content">
					<h2>예약 접수 현황</h2>

					<p>
						현재 예약이 없습니다.<br />
						어플 예약을 통해 보다 편리하게<br />
						하이모 서비스를 이용해보세요.
					</p>
				</div>
			</div>

			<div class="reservation-summary__bottom">
				<router-link
					:to="{ name: 'reservationApp' }"
					class="btn-rs btn-rs--apply"
					>예약 하기</router-link
				>
			</div>
		</div>
	</section>
</template>

<script>
import { formatDateString } from '@/utils/util';

export default {
	data() {
		return {
			isUserReservationStateList: null,
		};
	},
	computed: {
		user() {
			return this.$store.getters['userStore/user'];
		},
		userId() {
			return this.$store.getters['userStore/userId'];
		},
		userName() {
			return this.$store.getters['userStore/userName'];
		},
		isRegularUser() {
			return this.$store.getters['userStore/isRegularUser'];
		},
		reservationServiceCodeList() {
			return this.$store.getters[
				'reservationAppStore/reservationServiceCodeList'
			];
		},
		userReservationStateList() {
			return this.$store.getters[
				'reservationAppStore/userReservationStateList'
			];
		},
	},
	created() {
		if (this.isRegularUser) {
			this.fetchReservationServiceCodeList();
			this.fetchUserReservationStateList();
		}
	},
	methods: {
		async updateUserLevelToRegular() {
			const payload = {
				userId: this.userId,
				userName: this.userName,
				userHp: this.user.user_hp,
			};

			const { data } = await this.$store.dispatch(
				'userStore/updateUserLevelToRegular',
				payload,
			);

			const options = {
				okLabel: '확인',
				message: data.message,
			};
			this.showAlert(options);
		},
		async fetchReservationServiceCodeList() {
			await this.$store.dispatch(
				'reservationAppStore/getReservationServiceCodeList',
			);
		},
		async fetchUserReservationStateList() {
			const payload = { userId: this.userId };

			await this.$store.dispatch(
				'reservationAppStore/getUserReservationStateList',
				payload,
			);

			this.isUserReservationStateList =
				this.userReservationStateList.length > 0;
		},
		getReservationStatus({ IS_WAITING, STATUS_CODE }) {
			if (IS_WAITING === false && STATUS_CODE === '1') {
				return 'complete';
			}
			if (IS_WAITING === true && STATUS_CODE === '3') {
				return 'possible';
			}
			return 'waiting';
		},
		getReservationStatusClass({ IS_WAITING, STATUS_CODE }) {
			const status = this.getReservationStatus({ IS_WAITING, STATUS_CODE });
			return `rs-status__status--${status}`;
		},
		getFormatedReservationDate(str) {
			return formatDateString(str);
		},
		getFormatedReservationTime(str) {
			return str.replace('AM', '오전').replace('PM', '오후');
		},
		getReservationServiceName(code) {
			const item = this.reservationServiceCodeList.find(
				el => el.value === code,
			);
			return item ? item.name : '';
		},
		goToReservationApp(branchName) {
			this.$router.push({
				name: 'reservationApp',
				params: { branchName },
			});
		},
		goToReservationDetail() {
			this.$router.push({ name: 'reservation' });
		},
		goToReservationWaiting() {
			this.$router.push({ name: 'reservationWaiting' });
		},
	},
};
</script>

<style scoped>
.reservation-summary {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 15.625rem;
	border-radius: 0.125rem;
	background: #fff;
	overflow: hidden;
	box-shadow: 0px 1px 27px 0px rgba(50, 50, 50, 0.1);
}

.reservation-summary__top {
	flex: 1;
	display: flex;
	align-items: center;
	min-height: 12.8125rem;
	padding: 1.25rem 0.75rem;
}

.rs-status-list {
	width: 100%;
}

.rs-status-list__item {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 1.25rem 0;
	border-bottom: 1px solid #c8c8c8;
}

.rs-status-list__item:first-child {
	padding-top: 0;
	border-top: 0;
}

.rs-status-list__item:last-child {
	padding-bottom: 0;
	border-bottom: 0;
}

.rs-status {
	width: 54px;
}

.rs-status__status {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 48px;
	height: 48px;
	margin: 0 auto;
	border-radius: 50%;
	border: 1px solid #666;
	background: #fff;
	color: #666;
	font-size: 0.75rem;
	line-height: 1.2;
}

.rs-status__inner {
	max-width: 50%;
	text-align: center;
}

.rs-status__status--complete {
	border-color: transparent;
	background: var(--blue-color);
	color: #fff;
}

.rs-status__status--possible {
	border-color: var(--blue-color);
	color: var(--blue-color);
}

.rs-status__status--waiting {
	border-color: var(--secondary-color);
	color: var(--secondary-color);
}

.rs-detail {
	flex: 1;
	padding-left: 1.25rem;
}

.rs-detail__title {
	font-size: 0.75rem;
}
.rs-detail__text {
	font-size: 0.75rem;
}

.rs-button {
	width: 54px;
}

.rs-button__btn {
	width: 46px;
	height: 24px;
	border-radius: 12px;
	border: 1px solid #666;
	background: #fff;
	color: #666;
	font-size: 0.75rem;
	text-align: center;
	line-height: 1;
}

.rs-button__btn--cancel {
	border-color: var(--red-color);
	color: var(--red-color);
}

.rs-button__btn--apply {
	border-color: var(--blue-color);
	color: var(--blue-color);
}

.rs-content {
	display: flex;
	flex-flow: column wrap;
	align-items: center;
	width: 100%;
}

.rs-content h2 {
	margin-bottom: 1rem;
	font-size: 1.5rem;
	font-weight: 300;
}

.rs-content dl {
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	width: 100%;
	max-width: 200px;
}

.rs-content dt,
.rs-content dd {
	font-size: 0.875rem;
	line-height: 1.75;
}

.rs-content dt {
	flex: 0 0 30%;
	color: #666;
}

.rs-content dd {
	flex: 0 0 70%;
	color: #222;
	text-align: right;
}

.rs-content p {
	color: #666;
	font-size: 0.8125rem;
	line-height: 1.5;
	text-align: center;
}

.btn-rs {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 2.8125rem;
	border-top: 1px solid #ededed;
	background-color: #fff;
	font-size: 0.875rem;
}

.btn-rs--apply {
	border-top-color: #222;
	background-color: #222;
	color: #fff;
}
</style>
